import React from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'

import classes from './SocialIcons.module.scss'

const BASE_URL = 'https://www.getapp.com/resources'
const LINKEDIN_URL = 'https://www.linkedin.com/shareArticle?mini=true'
const TWITTER_URL = 'https://twitter.com/share?'
const FACEBOOK_URL = 'https://www.facebook.com/sharer/sharer.php?u='

const SocialIcons = ({ post }) => {
  const { permalink } = post
  const articleUrl = `${BASE_URL}/${permalink}/`

  const { addEvent } = useEventContext()

  return (
    <div className={clsx('SocialIcons', classes.root)}>
      <a
        href={`${TWITTER_URL}&url=${articleUrl}`}
        target="_blank"
        className="evnt"
        {...addEvent({
          name: 'click',
          engagementComponent: 'resources_article',
          engagementDestination: 'go-to_social_twitter',
          engagementDetails: 'icon_social_twitter',
          outboundSocialLinkClickCount: 1,
          outboundLinkType: 'social link',
          clickUrl: `${TWITTER_URL}&url=${articleUrl}`,
        })}
      >
        <IconButton className={classes.button}>
          <Icon icon={['fab', 'x-twitter']} className={classes.icon} />
        </IconButton>
      </a>
      <a
        href={`${LINKEDIN_URL}&url=${articleUrl}`}
        target="_blank"
        className="evnt"
        {...addEvent({
          name: 'click',
          engagementComponent: 'resources_article',
          engagementDestination: 'go-to_social_linkedin',
          engagementDetails: 'icon_social_linkedin',
          outboundSocialLinkClickCount: 1,
          outboundLinkType: 'social link',
          clickUrl: `${LINKEDIN_URL}&url=${articleUrl}`,
        })}
      >
        <IconButton className={classes.button}>
          <Icon icon={['fab', 'linkedin']} className={classes.icon} />
        </IconButton>
      </a>
      <a
        href={`${FACEBOOK_URL}${articleUrl}`}
        target="_blank"
        className="evnt"
        {...addEvent({
          name: 'click',
          engagementComponent: 'resources_article',
          engagementDestination: 'go-to_social_facebook',
          engagementDetails: 'icon_social_facebook',
          outboundSocialLinkClickCount: 1,
          outboundLinkType: 'social link',
          clickUrl: `${FACEBOOK_URL}${articleUrl}`,
        })}
      >
        <IconButton className={classes.button}>
          <Icon icon={['fab', 'facebook-square']} className={classes.icon} />
        </IconButton>
      </a>
    </div>
  )
}

export default SocialIcons
